import * as yup from "yup";
import { MSG } from "../constants/MSG";

const regex = ".*[a-zA-Z]+.*";

export const addHelpTopicSchema = yup.object().shape({
	name: yup
		.string()
		.trim()
		.required(MSG.REQUIRED_HELP_TOPIC_NAME)
		.matches(regex, MSG.REQUIRED_VALID_HELP_TOPIC),
});

export const addFAQCategorySchema = yup.object().shape({
	name: yup
		.string()
		.trim()
		.required(MSG.REQUIRED_CATEGORY_NAME)
		.max(30, "Category name must be at most 30 characters")
		.matches(regex, MSG.REQUIRED_VALID_CATEGORY),
});
export const addFaqQuerySchema = yup.object().shape({
	category_id: yup.number().required(MSG.REQUIRED_FAQ_CATEGORY),
	question: yup.string().trim().required(MSG.REQUIRED_FAQ_QUESTION),
	answer: yup.string().trim().required(MSG.REQUIRED_FAQ_ANSWER),
});
